import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import PeriodoSelector, { periodoInicial, rangoDePeriodo, etiquetaPeriodo } from "@/components/PeriodoSelector";

/**
 * ExportExcelFechasModal — selector de periodo (mes o rango) antes de descargar el Excel.
 * Props: open, onOpenChange, onExportar: async ({desde, hasta}) => void, titulo
 */
export default function ExportExcelFechasModal({ open, onOpenChange, onExportar, titulo = "Exportar Excel" }) {
  const [periodo, setPeriodo] = useState(periodoInicial);
  const [saving, setSaving] = useState(false);

  const descargar = async () => {
    setSaving(true);
    try {
      const r = rangoDePeriodo(periodo);
      await onExportar?.({ desde: r.desde || null, hasta: r.hasta || null });
      onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (saving) return; onOpenChange(v); }}>
      <DialogContent className="max-w-lg" data-testid="export-excel-fechas-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{titulo}</DialogTitle>
          <p className="text-sm text-muted-foreground">Elige el mes, o un rango de fechas. En "Rango" sin fechas se exporta todo el histórico.</p>
        </DialogHeader>
        <div className="mt-3"><PeriodoSelector value={periodo} onChange={setPeriodo} testid="export" /></div>
        <div className="text-xs text-muted-foreground mt-2" data-testid="export-periodo-label">Periodo: <b>{etiquetaPeriodo(periodo)}</b></div>
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="outline" disabled={saving} onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={descargar} disabled={saving} className="bg-primary hover:bg-primary/90" data-testid="export-descargar-btn">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-2" />}
            {saving ? "Descargando..." : "Descargar Excel"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
